<template>
  <div class="insu-desc-card">
    <div class="img-wrapper">
      <img 
        :src="cover" 
        alt="磐石保經，保險細項說明"
      >
    </div>
    <div class="card-content">
      <h3 
        class="card-title text-center"
        :style="{ color: desc.color }"
        v-text="desc.title"
      />
      <p :class="`card-desc ${desc.class}`">{{ desc.content }}</p>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      desc: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        cover: require(`@/assets/${this.desc.icon}.png`)
      };
    }
  };
</script>